import $ from "cash-dom";
import {validate} from "../systems/validate";
import {format} from "../systems/format";

export const phoneInputComponent = (root, {defaultValue} = {}) => {
    const $root = $(root);
    const validateCorrectIcon = $root.find('.validate-correct').get(0);
    const input = $root.find('input').get(0);

    input.value = defaultValue || '';

    const parseValue = format.phone;
    const formatValue = format.view.phone;

    const onInput = () => {
        const value = parseValue(input);
        input.value = formatValue(value);

        const isValid = validate.phone()(value);

        if (validateCorrectIcon)
            validateCorrectIcon.style.opacity = isValid ? '1' : '0';
    };

    input.oninput = onInput;

    if (defaultValue)
        onInput();
};
